// import React from 'react'
// import { Navigate } from 'react-router-dom'

// const FormPrivateRoute = ({ children }) => {
//   const isLoggedIn = localStorage.getItem("tokken");
//   const paymentStatus = JSON.parse(localStorage.getItem("Payment Status"));

//   // Agar user login nahi hai ya payment confirm nahi hai toh dashboard par redirect karo
//   if (!isLoggedIn || !paymentStatus || paymentStatus.Payment !== "confirm") {
//     return <Navigate to="/student/dashboard" replace />;
//   }

//   return children;
// }

// export default FormPrivateRoute;


import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom'
import authService from '../../services/auth.service';

const FormPrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  
  useEffect(() => {
     authService.getUser(dispatch);
  }, []);

const isLoggedIn = localStorage.getItem("auth_token")
   const studentInformation = useSelector((state) => state.auth.studentData);

    // console.log(studentInformation)

  if ((studentInformation.status === 0 || studentInformation.status === 2)  ) {
    return <Navigate to="/student/dashboard" replace />;
  }

  // console.log(studentInformation.status)

  // console.log("chal raha hai")

  return children;
}

export default FormPrivateRoute;